import { Component, OnInit, OnDestroy }  from '@angular/core';
import { Router, ROUTER_DIRECTIVES, ActivatedRoute } from '@angular/router';
import {ITowersLess12} from './towers-less-12';
import {ITowersTraconsImportstepsMsg} from './towers-tracons-import-steps-msg';
import {TowersTraconsImportStepsService} from './towers-tracons-import-steps.service';
import {SystemControlElem} from '../../../shared/system-control-elem';
import {SystemControlService} from '../../../shared/system-control.service';
import {SystemControl} from '../../../shared/system-control';

import {DataTable} from 'primeng/primeng';
import {Column} from 'primeng/primeng';
import {Header} from 'primeng/primeng';
import {Button} from 'primeng/primeng';
import {Paginator} from 'primeng/primeng';


@Component({
    //templateUrl: 'app/system-management/towers-tracons-import/towers-tracons-import.component.html',
    template: require('./towers-tracons-import-steps.component.html'),
    directives: [ROUTER_DIRECTIVES,DataTable,Column, Header, Paginator],
    providers:[TowersTraconsImportStepsService,SystemControl]
})
export class TowersTraconsImportStepsComponent  implements OnInit{
    pageTitle: string = 'Towers Tracons Import Steps ';
    errorMessage: string;
    private sub: any;
    cols: any[];
    towersLessThan12: ITowersLess12;
    towersImportMsg:ITowersTraconsImportstepsMsg;
    towersReforecastMsg:ITowersTraconsImportstepsMsg;
    showSpinner:boolean;
    showDataTable: boolean;
    showOpsnetImportMsg:boolean;
    showAOPSReforecastMsg: boolean;
    systemControl:SystemControl;
    systemControlElem:SystemControlElem;
    private fyYear:number;

     constructor(private route: ActivatedRoute,
                private router: Router,
                private _towerstraconsImportService: TowersTraconsImportStepsService,
                private _systemControl:SystemControl,
                private _systemControlService:SystemControlService){
                    this.showSpinner = false;
                    this.showDataTable =false;
                    this.showOpsnetImportMsg= false;
                    this.showAOPSReforecastMsg =false;
                    this.systemControl = _systemControl;
    }

   ngOnInit (): void{
      // this.fyYear=this.systemControl.getFyYear();
      //  alert(" ngOnInit this.fyYear " + this.fyYear);
       this._systemControlService.getSystemControl()
            .subscribe(
            systemControlElem => this.systemControlElem = systemControlElem,
            error => this.errorMessage = <any>error,
            ()=>{
                this.fyYear = this.systemControlElem.fyYear;
                console.log("fyYear and ffcYear in SystemControl:" + this.fyYear );
            }
            );
   }
   getTowersImportStepsLess12(): void{
        this.showSpinner = true;
        this._towerstraconsImportService.getTowersImportStepsLess12()
                    .subscribe(
                        towersLessThan12 => this.towersLessThan12 = towersLessThan12,
                        error =>  this.errorMessage = <any>error,
                        ()=>{
                            this.showDataTable =true;
                            this.showSpinner = false;
                        });
                this.cols = [
                    {field: "locid", header: 'Locid'},
                    {field: "sumAc", header: ' Air Carrier'},
                    {field: "sumAt", header: ' Air Taxi'},
                    {field: "sumGa", header: ' General Aviation'},
                    {field: "sumMil", header: ' Military'},
                    {field: "sumLocGa", header: ' Civil'},
                    {field: "sumLocMil", header: ' Local Military'},
                    {field: "sumTotOvers", header: ' Total Overflights'},
                ]
    }
   startOpsnetTowersImport(): void{
        this.showSpinner = true;
        this._towerstraconsImportService.startOpsnetTowersImport()
                    .subscribe(
                        towersImportMsg => this.towersImportMsg = towersImportMsg,
                        error =>  this.errorMessage = <any>error,
                        ()=>{
                            this.showOpsnetImportMsg =true;
                            this.showSpinner = false;
                        });
    }
    reforecastAOPS(): void{
        this.showSpinner = true;
        this._towerstraconsImportService.reforecastAOPS()
                    .subscribe(
                        towersReforecastMsg => this.towersReforecastMsg = towersReforecastMsg,
                        error =>  this.errorMessage = <any>error,
                        ()=>{
                            this.showAOPSReforecastMsg =true;
                            this.showSpinner = false;
                        });
    }

}


/** WEBPACK FOOTER **
 ** ./app/system-management/towers-tracons-import/towers-tracons-import-steps/towers-tracons-import-steps.component.ts
 **/